import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@renderer/components/Button'

interface PrinterGuideModalProps {
  isOpen: boolean
  onClose: () => void
}

export const PrinterGuideModal: React.FC<PrinterGuideModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">{t('printerGuide.title')}</h2>

        <div className="space-y-6">
          {/* FAQ 1: Enabling double inch cut */}
          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gray-800">
              {t('printerGuide.faq1.question')}
            </h3>
            <div className="ml-4 text-sm text-gray-600">
              <p>{t('printerGuide.faq1.answer')}</p>
            </div>
          </div>

          {/* FAQ 2: Secondary and Tertiary Printer */}
          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gray-800">
              {t('printerGuide.faq2.question')}
            </h3>
            <div className="ml-4 text-sm text-gray-600">
              <p>{t('printerGuide.faq2.answer')}</p>
            </div>
          </div>

          {/* FAQ 3: Remote Printer */}
          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gray-800">
              {t('printerGuide.faq3.question')}
            </h3>
            <div className="ml-4 text-sm text-gray-600">
              <p>{t('printerGuide.faq3.answer')}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3 pt-4 border-t border-gray-200">
          <Button
            text={t('printerGuide.buttons.close')}
            variant="secondary"
            onClick={onClose}
            className="!px-6 !py-2 !text-base"
          />
        </div>
      </div>
    </div>
  )
}

